const getEntityById = (state, type, id) => {
  const types = state[type]

  if (!types) {
    throw new Error(`Unable to find type "${type}" in app state.`)
  }

  return types[id]
}

export default getEntityById



// WEBPACK FOOTER //
// ./src/selectors/getEntityById.js